import React, { useState, useEffect } from 'react'
import { toast } from '@CommonComponents/toast'
import { FormField, usePageRequest } from '@CommonComponents'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { ltiLogs as endpoints } from '@URLS'
import { Pagination } from '@CommonComponents/buttons'

const LogTable = () => {
  // Main Context
  const [currentState, dispatch] = useStateValue()
  // Local state for search field
  const [searchLogValue, setSearchLogValue] = useState('')
  const [searchLogQuery, setSearchLogQuery] = useState('')
  // Local state for pagination. The server pages logs 20 at a time.
  const [paginationRate, setPaginationRate] = useState(20)
  const [totalLogs, setTotalLogs] = useState(0)
  const {
    page: currentPage,
    attempt: pageAttempt,
    request: changePage,
    settle: settlePage,
  } = usePageRequest()

  useEffect(() => {
    // A later page or search replaces this load, so its response is dropped.
    let cancelled = false
    const fetchLogs = async () => {
      let formData = new FormData()
      formData.append('logId', searchLogQuery)
      formData.append('currentPage', currentPage)
      if (currentState.userId) {
        formData.append('userId', currentState.userId)
      }
      try {
        let response = await client.post(endpoints.getLtiLogs(), formData)
        if (cancelled) return
        setPaginationRate(response.data.pagRate)
        setTotalLogs(response.data.total)
        dispatch({ type: 'updateLogs', logArray: response.data.logs })
        settlePage()
      } catch (err) {
        if (cancelled) return
        settlePage(err)
        console.log(err)
        toast.error(`There was an error trying to get the logs. Please refresh the page. ${err}`)
      }
    }
    fetchLogs()
    return () => {
      cancelled = true
    }
  }, [searchLogQuery, pageAttempt])

  let logRows = currentState.logs.map(log => ({
    id: log.id,
    time: log.time,
    course: log.coursenum,
    contextId: log.params.context_id,
    contextTitle: log.params.context_title,
    roles: log.roles,
  }))

  let columns = [
    'Log ID',
    'Launch Time (UTC)',
    'Course',
    'Context ID',
    'Context Title',
    'Roles',
    'Actions',
  ]

  return (
    <div>
      <div>
        <FormField
          name="logId"
          label="Log ID: "
          handler={event => setSearchLogValue(event.target.value)}
        />
        <a
          className="btn btn-myed btn-primary btn-primary-myed"
          onClick={() => setSearchLogQuery(searchLogValue)}
        >
          Search
        </a>
      </div>
      <Pagination
        label="Pagination, top"
        currentPage={currentPage}
        setCurrentPage={changePage}
        rate={paginationRate}
        total={totalLogs}
      />
      <table className="table table-striped table-hover table-condensed">
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={i}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {logRows.map(row => (
            <tr key={`${row.id}`}>
              <td>{row.id}</td>
              <td>{row.time}</td>
              <td>{row.course}</td>
              <td>{row.contextId}</td>
              <td>{row.contextTitle}</td>
              <td>{row.roles}</td>
              <td>
                <a
                  className="btn btn-myed btn-primary btn-primary-myed"
                  onClick={() =>
                    dispatch({ type: 'selectLog', selectedLog: row.id })
                  }
                >
                  View
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        label="Pagination, bottom"
        currentPage={currentPage}
        setCurrentPage={changePage}
        rate={paginationRate}
        total={totalLogs}
      />
    </div>
  )
}
export default LogTable
